module.exports = "/assets/data/7b0b726baa4105e57bbf820163e0ddb5-AB22.data.json";